import { TemplateRef, Component, ContentChildren, QueryList, ViewChildren, ViewChild, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DOCUMENT } from '@angular/common';

// Services.
import { ToastService } from '@services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { QSignerHomeService } from '@services/qsignerhome.service';
import { LocalStorageService } from 'ngx-webstorage';
import { ApiServerService } from '@services/api-server.service';
import { QsignerService } from '@services/qsigner.service';

// Para las traducciones.
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale, ptBrLocale, enGbLocale } from 'ngx-bootstrap/locale';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

// Components
import { PdfViewerComponent } from 'ng2-pdf-viewer';

// Entorno.
import { environment } from '@environments/environment';

// Helpers
import { scrollToTop, obtainApi, setToken, obtainTokenAndCompanyParamsSigner, showToaster, manageAES } from '@helpers';
import { take } from 'rxjs';

import { UrlShortenerService } from '@services/url-shortener.service';

// Establecer lenguaje.
defineLocale('es', esLocale);

@Component({
  selector: 'qsignerhome',
  templateUrl: './qSignerHome.component.html',
  styleUrls: ['./qSignerHome.component.scss'],
})
export class QSignerHomeComponent implements OnInit {
  public oLangWebViewInterface = window['nsWebViewInterface'];
  // Parametros posibles en la ruta
  public urlParams: any;
  public id: any;
  public idCliente: any;
  public idIdioma: any;
  public qbrowser: any;
  public category: any;
  public user: any;
  public isQSignerEmail: any;
  public date: any;
  public requiereCustomer: any;
  public email: any;
  public eventType: any;
  public isNative: any;
  public phoneNumber: any = null;

  // Para los service params.
  public sp: any;

  // Listado de documentos inicial.
  public documentos: any;
  public documents: any;
  public document: any;

  // Numero de documento actual.
  public currentDocument: number;

  // Bandera: Para mostrar la lista de documentos.
  public showDocumentList: boolean;

  // Bandera: Para mostrar los documentos Pdf.
  public showDocumentPdf: boolean;

  // Bandera: Para mostrar la pantalla final con la posible descarga de los documentos firmados.
  public showDownloadScreen: boolean;

  // Bandera: Para mostrar los datos.
  public showData: boolean;

  // Para el loading principal.
  public loadingData: boolean;

  // Para el loading de documento.
  public loadingDocument: boolean;

  // Para el boton de imprimir.
  private documentPrint: any;

  // Bandera: Para saber si hay banners o no.
  public hasBanners;

  // Listado de banners inicial.
  public bannerList: any;

  // Lenguaje.
  public locale: any;

  public first = false;
  public allDocuments: any[] = [];

  // PDF params
  public page: number;
  public totalPages: number;
  public isLoaded: boolean;
  public zoom: number;
  public datepicker: any;
  public modalRef: BsModalRef | undefined;
  public message: string | undefined;

  // Bandera: Si tiene documento pdf.
  public hasDocument: boolean | undefined;

  // URL.
  private url: string = environment.url;

  // Para las firmas.
  public idsSignature: any;
  public ids: any;

  public idsButtons: any;
  public model: any;
  public modelo: any;

  // Ruta al pdf.
  public pdfSrc: any;
  public loopNum: any;

  // Documentos seleccionados.
  public checkedDocuments: any;

  public nativo;
  public sizeSign: number = 3000;
  public dmsEventId: any;

  // Existentes
  public blockBody: boolean | undefined;
  public hideElements: boolean;
  public loadingDataWebPrinter: boolean;
  public sendingData: boolean | undefined;
  public showNextButton: boolean;

  public totalDocuments: number;
  public idDocumento: any;
  public documentToPrint: any;
  public elementToPrint: string;
  public loadingDownloadSingDocument: boolean;

  // Todos los documentos seleccionados por el cliente en la primera pantalla.
  public selectedDocumentsList: String[] = [];

  // Childs.
  @ContentChildren(QSignerHomeComponent)
  public form!: QueryList<QSignerHomeComponent>;
  @ViewChildren('signature')
  public firmas!: QueryList<any>;
  @ViewChildren('tab')
  public tab!: QueryList<QSignerHomeComponent>;
  @ViewChildren('info')
  public info!: QueryList<QSignerHomeComponent>;
  @ViewChild('template')
  public template!: TemplateRef<any>;
  documentosToDownload: any[] = [];

  @ViewChild('pdfViewer')
  pdfViewer!: PdfViewerComponent;

  contador: any = 0;
  numberList: any[] = [];
  notDownloadDocument: boolean = false;

  // Traducciones
  public getting_information_label: string = '';
  public error_get_data_label: string = '';
  public error_get_document_label: string = '';
  public require_fields_label: string = '';
  public error_client_label: string = '';
  public send_data_label: string = '';
  public printed_label: string = '';
  public signed_label: string = '';
  public it_has_a_total_of_label: string = '';
  public pages_to_review_label: string = '';
  public sing_title_label: string = '';
  public without_title_label: string = '';
  public mandatory_fields_label: string = '';
  public yes_label: string = '';
  public no_label: string = '';
  public answer_label: string = '';
  public selected_options_label: string = '';
  public finish_successfully_label: string = '';
  public choose_download_document_label: string = '';
  public download_label: string = '';
  public downloading_label: string = '';
  public finish_label: string = '';
  public available_documents_label: string = '';
  public available_documents_description_label: string = '';
  public continue_label: string = '';
  public document_label: string = '';
  public loadingSendDocuments: boolean = false;
  withoutId: any;
  arrayDmsEventId: any;
  typeRequiredError: string = '';
  require_require_max_size_sing_label: any;

  // Configuración inicial y traducciones.
  constructor(
    @Inject(DOCUMENT) private documentDOM: Document,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastService,
    private translateService: TranslateService,
    public localeService: BsLocaleService,
    public qsignerhomeService: QSignerHomeService,
    public apiServerService: ApiServerService,
    public qsignerService: QsignerService,
    public storage: LocalStorageService,
    public urlShortenerService: UrlShortenerService
  ) {
    // Establecer valores iniciales por defecto.
    this.urlParams = [];
    this.sp = {};
    this.documentos = {};
    this.currentDocument = 0;
    this.showDocumentList = false;
    this.showDocumentPdf = false;
    this.showData = false;
    this.showDownloadScreen = false;
    this.loadingData = true;
    this.loadingDocument = false;
    this.category = 1;
    this.hideElements = false;
    this.page = 1;
    this.totalPages = 0;
    this.idsSignature = [];
    this.idsButtons = [];
    this.model = {};
    this.modelo = {};
    this.loadingDataWebPrinter = false;
    this.nativo = false;
    this.showNextButton = false;
    this.isLoaded = false;
    this.zoom = 1;
    this.hasBanners = false;
    this.totalDocuments = 0;
    this.documentToPrint = {};
    this.elementToPrint = '';
    this.loadingDownloadSingDocument = false;
    // Comprobar si es nativo o no.
    this.oLangWebViewInterface.on('checkIsNative', () => {
      this.nativo = true;
    });
    // Cargar las traduciones.
    this.translates();
  }

  // Se obtienen los parametros de la url y se consultan los documentos correspondientes.
  ngOnInit(): void {
    // Manage params
    this.activatedRoute.queryParams.subscribe((params) => {
      this.urlParams = Object.keys(params);
      for (var i = 0; i < this.urlParams.length; i++) {
        switch (this.urlParams[i]) {
          case 'a':
            this.id = params[this.urlParams[i]] ? manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt') : '';
            break;
          case 'b':
            this.idCliente = params[this.urlParams[i]] ? manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt') : '';
            break;
          case 'c':
            this.idIdioma = params[this.urlParams[i]] ? manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt') : '';
            break;
          case 'qbrowser':
            this.qbrowser = params[this.urlParams[i]];
            break;
          case 'd':
            this.category = params[this.urlParams[i]] ? manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt') : '';
            break;
          case 'e':
            this.user = params[this.urlParams[i]] ? manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt') : '';
            break;
          case 'f':
            this.isQSignerEmail = params[this.urlParams[i]] ? manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt') : '';
            break;
          case 'g':
            this.date = params[this.urlParams[i]] ? manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt') : '';
            break;
          case 'h':
            this.requiereCustomer = params[this.urlParams[i]] ? manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt') : '';
            break;
          case 'i':
            this.email = params[this.urlParams[i]] ? manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt') : '';
            break;
          case 'j':
            this.eventType = params[this.urlParams[i]] ? manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt') : '';
            break;
          case 'k':
            this.isNative = params[this.urlParams[i]] ? manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt') : 'false';
            break;
          case 'l':
            this.phoneNumber = params[this.urlParams[i]] ? manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt') : '';
            break;
          case 'm':
            this.dmsEventId = params[this.urlParams[i]] ? manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt') : '';
            this.splitEventDms();
            break;
          case 'n':
            this.withoutId = params[this.urlParams[i]] ? manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt') : '';
            break;
        }
      }
      // Comprobar datos obligatorios.
      if ((!this.id && !this.idCliente && this.category && this.user && this.eventType) || !this.idIdioma) {
        showToaster(this.toastService, 'error', this.translateService, 'COMMON.ERROR', this.error_get_data_label);
      } else {
        // Determinar idioma.
        if (this.idIdioma) {
          switch (this.idIdioma) {
            case 'es':
              this.locale = esLocale;
              this.idIdioma = 'es';
              break;
            case 'pt':
              this.locale = ptBrLocale;
              this.idIdioma = 'pt';
              break;
            case 'en':
              this.locale = enGbLocale;
              this.idIdioma = 'en';
              break;
            default:
              this.locale = esLocale;
              this.idIdioma = 'es';
              break;
          }
          defineLocale(this.idIdioma, this.locale);
          this.localeService.use(this.idIdioma);
        }
        // Obtener api.
        obtainApi(this.qsignerhomeService, this.url, this.toastService).then((api: any) => {
          obtainTokenAndCompanyParamsSigner(api, this.storage, this.qsignerhomeService, this.toastService, this.apiServerService, this.url, this.idCliente).then(
            (serviceParams: any) => {
              // Com probar si tiene o no tiene acceso a la api.
              if (serviceParams === 'NO_CLIENT') {
                showToaster(this.toastService, 'error', this.translateService, 'COMMON.ERROR', this.error_client_label);
                this.loadingData = false;
                this.showDocumentList = true;
              } else {
                // Coger los datos de la api.
                this.sp = serviceParams;
                // Obtener los documentos.
                this.obtainDocumentsList(serviceParams['token'], serviceParams['companyParams']);
                // Get banners from OR ref (id)
                this.getBanners(this.id);
              }
            }
          );
        });
      }
    });
    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        this.setDynamicSize();
      }, 500);
    });
  }

  splitEventDms() {
    this.arrayDmsEventId = this.dmsEventId.split(',');
  }

  public ngAfterViewInit(): void {
    this.oLangWebViewInterface.emit('checkIsNative', true);
  }

  // Cargar las traduciones.
  public translates() {
    this.translateService.get('GETTING_INFORMATION').subscribe((value) => {
      this.getting_information_label = value;
    });
    this.translateService.get('COMMON.ERROR_GET_DATA').subscribe((value) => {
      this.error_get_data_label = value;
    });
    this.translateService.get('COMMON.ERROR_GET_DOCUMENT').subscribe((value) => {
      this.error_get_document_label = value;
    });
    this.translateService.get('REQUIRE_FIELDS').subscribe((value) => {
      this.require_fields_label = value;
    });
    this.translateService.get('REQUIRE_MAX_SIZE_SING').subscribe((value) => {
      this.require_require_max_size_sing_label = value;
    });
    this.translateService.get('COMMON.ERROR_CLIENT').subscribe((value) => {
      this.error_client_label = value;
    });
    this.translateService.get('SEND_DATA').subscribe((value) => {
      this.send_data_label = value;
    });
    this.translateService.get('PRINTED').subscribe((value) => {
      this.printed_label = value;
    });
    this.translateService.get('SIGNED').subscribe((value) => {
      this.signed_label = value;
    });
    this.translateService.get('IT_HAS_A_TOTAL_OF').subscribe((value) => {
      this.it_has_a_total_of_label = value;
    });
    this.translateService.get('PAGES_TO_REVIEW').subscribe((value) => {
      this.pages_to_review_label = value;
    });
    this.translateService.get('SIGN_TITLE').subscribe((value) => {
      this.sing_title_label = value;
    });
    this.translateService.get('SIGNER.WITHOUT_TITLE').subscribe((value) => {
      this.without_title_label = value;
    });
    this.translateService.get('MANDATORY_FIELDS').subscribe((value) => {
      this.mandatory_fields_label = value;
    });
    this.translateService.get('SIGNER.YES').subscribe((value) => {
      this.yes_label = value;
    });
    this.translateService.get('SIGNER.NO').subscribe((value) => {
      this.no_label = value;
    });
    this.translateService.get('CLEAN_ANSWER').subscribe((value) => {
      this.answer_label = value;
    });
    this.translateService.get('SIGNER.SELECT_OPTION').subscribe((value) => {
      this.selected_options_label = value;
    });
    this.translateService.get('FINISH_SUCCESSFULLY').subscribe((value) => {
      this.finish_successfully_label = value;
    });
    this.translateService.get('CHOOSE_DOWNLOAD_DOCUMENT').subscribe((value) => {
      this.choose_download_document_label = value;
    });
    this.translateService.get('DOWNLOAD').subscribe((value) => {
      this.download_label = value;
    });
    this.translateService.get('DOWNLOADING').subscribe((value) => {
      this.downloading_label = value;
    });
    this.translateService.get('FINISH').subscribe((value) => {
      this.finish_label = value;
    });
    this.translateService.get('AVAILABLE_DOCUMENTS').subscribe((value) => {
      this.available_documents_label = value;
    });
    this.translateService.get('AVAILABLE_DOCUMENTS_DESCRIPTION').subscribe((value) => {
      this.available_documents_description_label = value;
    });
    this.translateService.get('CONTINUE').subscribe((value) => {
      this.continue_label = value;
    });
    this.translateService.get('COMMON.DOCUMENT').subscribe((value) => {
      this.document_label = value;
    });
  }

  // Obtener documentos.
  private obtainDocumentsList(token: any, apiServer: any): void {
    // Crear objeto de consulta.
    let objConsulta = {
      documento: {
        reference: this.id,
        returnDocument: 'false',
        event: this.eventType,
        isQsignerEmail: true,
      },
      companyParams: apiServer,
      token: false,
    };
    // Petición para obtener los documentos.
    this.qsignerhomeService.getDocuments(this.url, objConsulta).subscribe((datos: any) => {
      if (environment.ERROR_API_CODES.includes(datos['code'])) {
        showToaster(this.toastService, 'error', this.translateService, 'COMMON.ERROR', datos['message']);
        this.loadingData = false;
      } else {
        // Deshabilitar impresión.
        this.documentPrint = undefined;
        // Comprobar si hay datos y setear el token.
        if (datos && datos.tokenObj && datos.api) {
          setToken(datos.api, datos.tokenObj, this.storage);
        }
        // Comprobar si hay documentos.
        if (!datos.documents) {
          // Mensaje para el usuario.
          showToaster(this.toastService, 'error', this.translateService, 'COMMON.ERROR', this.error_get_data_label);
        } else {
          // Limpiar los datos e incluir solo los que tengan la propiedad documents.
          var cleanedDocuments = [];
          for (var i = 0; i < datos.documents.length; i++) {
            if (datos.documents[i] !== '') {
              cleanedDocuments.push(datos.documents[i]);
            }
          }
          // Cargar los documentos en la varible principal.
          this.documentos = { documents: cleanedDocuments };
          // Quitar loading principal.
          this.loadingData = false;
          // Mostrar la lista de documentos.
          if (this.requiereCustomer == 'false') {
            this.showDocumentList = true;
          }
          // Establecer inicialmente todos los documentos como desmarcados.
          this.checkedDocuments = false;

          if (this.first == false && this.requiereCustomer == 'true') {
            if (this.documentos && this.documentos.documents && this.documentos.documents.length > 0) {
              for (let i = 0; i < this.documentos.documents.length; i++) {
                if (this.documentos.documents[i] && this.documentos.documents[i]['documentId'] && this.arrayDmsEventId.includes(this.documentos.documents[i]['documentId'])) {
                  this.allDocuments.push(this.documentos.documents[i]);
                }
              }
            }
            this.documentos.documents = this.allDocuments;
            this.documents = this.allDocuments;
            this.totalDocuments = this.documentos['documents'].length;
            this.requiereCustomer == 'true' ? this.cargarDocumento() : undefined;
          }
        }
      }
    });
  }

  cargarDocumento() {
    this.ids = this.arrayDmsEventId;
    this.hideElements = false;
    this.blockBody = false;
    this.loopNum = undefined;

    this.loadingDataWebPrinter = true;
    let idDocumento = this.ids[0];
    obtainApi(this.qsignerhomeService, this.url, this.toastService).then((api) => {
      obtainTokenAndCompanyParamsSigner(api, this.storage, this.qsignerhomeService, this.toastService, this.apiServerService, this.url, this.idCliente).then(
        (serviceParams: any) => {
          this.obtainSigns(true, true, serviceParams['token'], serviceParams['companyParams']);
        }
      );
    });
  }

  /*
    BANNERS.
  */

  // Obtener banners por referencia de orden.
  private getBanners(refOrder: any): void {
    obtainApi(this.qsignerhomeService, this.url, this.toastService).then((api) => {
      obtainTokenAndCompanyParamsSigner(api, this.storage, this.qsignerhomeService, this.toastService, this.apiServerService, this.url, this.idCliente).then(
        (serviceParams: any) => {
          this.getBannersQIS(serviceParams['token'], serviceParams['companyParams'], refOrder);
        }
      );
    });
  }

  // Obtener banners.
  private getBannersQIS(token: any, apiServer: any, refOrder: any): void {
    // Crear objeto de consulta.
    let objConsulta = {
      banner: {
        refOrder: refOrder,
      },
      companyParams: apiServer,
      token: token,
    };
    this.qsignerhomeService.getBanners(this.url, objConsulta).subscribe((callback: any) => {
      // Si existen banners setear el token.
      if (callback && callback.tokenObj && callback.api) {
        setToken(callback.api, callback.tokenObj, this.storage);
      }
      // Cargar banners si existen.
      if (callback.urls) {
        // Cambiar bandera.
        this.hasBanners = true;
        // Obtener la lista de banners.
        this.bannerList = callback.urls;
      }
    });
  }

  /*
    PARA LOS PDFS.
  */

  // Obtener nombre de los documentos y las firmas.
  public obtenerInfo(): void {
    this.totalDocuments = this.documentos['documents'].length;
    this.hideElements = false;
    this.blockBody = false;
    this.loadingDataWebPrinter = true;
    this.ids = [];

    // Obtener lista de nombres de los documentos.
    if (this.requiereCustomer === 'false') {
      this.ids = Object.keys(this.modelo);
    } else {
      this.ids = this.dmsEventId.split(',');
    }

    // Comprobar si esta vacio.
    if (this.ids && this.ids.length && this.ids.length <= 2) {
      // Si esta vacio deshabilitar el boton de siguiente documento.
      this.showNextButton = false;
    }
    // Quitar el nombre "file-data" de la lista de nombres de ficheros.
    if (this.ids && this.ids.length && this.ids.length > 1) {
      for (let i = 0; i < this.ids.length; i++) {
        if (this.ids[i].indexOf('file-data') >= 0) {
          this.ids.splice(i, 1);
        }
      }
      this.totalDocuments = this.ids.length;
      // Obtener firmas.
      this.obtainSigns(false, true, this.sp['token'], this.sp['companyParams']).then(() => {
        if (!this.hasDocument) {
          // this.obtainSigns(true, false, this.sp['token'], this.sp['companyParams']);
          this.loadDocument(this.sp['token'], this.sp['companyParams']);
        }
      });
      this.showData = true;
    }
  }

  // Obtener firmas.
  private async obtainSigns(downloadDocument: boolean, downloadSing: boolean, token: any, apiServer: any): Promise<void> {
    if (downloadDocument === true) {
      this.loadingDocument = true;
    }
    if (downloadDocument === false) {
      this.loadingData = true;
    }
    this.showDocumentList = false;
    // Limpiar la lista de firmas.
    this.idsSignature = [];
    // Obtener el id del documento del que se quieren cojer las firmas.
    this.idDocumento = this.ids[this.currentDocument].replace('file-', '');
    // Preparar opciones para la consulta acerca del documento que se necesita.
    let obj: any = {};
    obj['documento'] = {};
    obj['token'] = token;
    obj['companyParams'] = apiServer;
    obj['documento']['eventId'] = 11;
    obj['documento']['reference'] = this.id;
    // Si es necesario se descarga el documento pdf.
    if (downloadDocument === true) {
      await this.getUniqueDocument(this.idDocumento, 'false', obj);
    }
    // Recorrer todos los documnetos.
    for (let j = 0; j < this.documentos.documents.length; j++) {
      // Comprobar si el el documento quie se busca.
      if (this.documentos.documents[j] && this.documentos.documents[j].documentId === this.idDocumento) {
        // Preparar parametro "authorizationId".
        if (this.documentos.documents[j].authorizationId) {
          obj['documento']['authorizationId'] = this.documentos.documents[j].authorizationId;
        } else {
          // this.noSigns = true;
        }
        // Preparar parametro "signatureId".
        if (this.documentos.documents[j].signatureId) {
          obj['documento']['signatureId'] = this.documentos.documents[j].signatureId;
        } else {
          // this.noAuths = true;
        }
        // Preparar parametro "category".
        if (this.category) {
          obj['documento']['category'] = this.category;
        } else {
          obj['documento']['category'] = 1;
        }
        this.loopNum = j;
      }
    }
    // Obtener firmas y autorizaciones.
    if ((obj && obj['documento']['authorizationId']) || obj['documento']['signatureId']) {
      // Realizar llamada para obtener las firmas y las autorizaciones.
      this.qsignerService.getSigns(this.url, obj).subscribe((datos: any) => {
        // Setear token.
        if (datos && datos.tokenObj && datos.api) {
          setToken(datos.api, datos.tokenObj, this.storage);
        }
        // Limpiar objeto documents
        this.documents = {};
        this.documents = this.documentos.documents[this.loopNum];
        // Añadir firmas.
        if (datos && datos['signatures']) {
          this.documents['signatures'] = datos['signatures'];
        }
        // Añadir autorizaciones.
        if (datos && datos['authorization']) {
          this.documents['authorization'] = datos['authorization'];
        }
        // Añadir la propiedad de visible a las firmas.
        if (this.documents && this.documents.signatures && this.documents.signatures.length > 0) {
          for (let i = 0; i < this.documents.signatures.length; i++) {
            this.documents.signatures[i]['visible'] = true;
          }
        }

        // Añadir la propiedad de visible a los componentes.
        if (this.documents && this.documents.authorization && this.documents.authorization.length) {
          for (let i = 0; i < this.documents.authorization.length; i++) {
            this.documents.authorization[i]['visible'] = true;
          }
        }

        // Obtener campos
        if (this.documents && this.documents.authorization && this.documents.authorization.length) {
          for (let i = 0; i < this.documents.authorization.length; i++) {
            if (this.documents.authorization[i] && this.documents.authorization[i].fixedValue && this.documents.authorization[i].fixedValue.indexOf('~') >= 0) {
              if (this.documents && this.documents.authorization[i] && this.documents.authorization[i].fixedValue && this.documents.authorization[i].fixedValue.indexOf('~') >= 0) {
                var camposSplit = this.documents.authorization[i].fixedValue.split('~');
                this.documents.authorization[i].fixedValue = camposSplit;
              }
            }
          }
        }
        this.numberList = [];
        // obtener numero de firmas validas para ser mostradas.
        if (this.requiereCustomer === 'true') {
          if (this.documents && this.documents['signatures']) {
            this.documents['signatures'].forEach((element: any, index: number) => {
              if (element['customerSign']) {
                this.numberList.push(element);
              }
            });
          }
        } else {
          if (this.documents && this.documents['signatures']) {
            this.documents['signatures'].forEach((element: any, index: number) => {
              if (element['advisorSign']) {
                this.numberList.push(element);
              }
            });
          }
        }

        this.documents['signatures'] = this.numberList;
        // Pdf.
        if (this.documents && this.documents.document) {
          this.page = 1;
          this.pdfSrc = 'data:application/pdf;base64,' + this.documents.document;
          this.hasDocument = true;
        } else {
          this.hasDocument = false;
        }
        this.loadingDataWebPrinter = false;
        this.showDocumentList = false;
        // Deshabilitar loading.
        if (downloadDocument === true) {
          this.loadingDocument = false;
        }
        if (downloadDocument === false) {
          this.loadingData = false;
        }
      });
    } else {
      this.documents = { entidad: 1 };
      if (this.documentos.documents[this.loopNum].document) {
        this.pdfSrc = 'data:application/pdf;base64,' + this.documentos.documents[this.loopNum].document;
        this.hasDocument = true;
      } else {
        this.hasDocument = false;
      }
      this.loadingDataWebPrinter = false;
      this.showDocumentList = false;
      this.blockBody = true;

      if (this.ids && this.ids.length && this.ids.length > 1) {
        this.showNextButton = true;
      } else {
        this.documents = {};
        this.model = {};
        this.document = {};
        this.idsButtons = [];
        this.showNextButton = false;
      }
      // Deshabilitar loading.
      if (downloadDocument === true) {
        this.loadingDocument = false;
      }
      if (downloadDocument === false) {
        this.loadingData = false;
      }
    }
    this.showData = true;
  }

  public async loadDocument(token: any, apiServer: any): Promise<void> {
    // Obtener el id del documento.
    this.idDocumento = this.ids[this.currentDocument].replace('file-', '');
    // Preparar opciones para la consulta acerca del documento que se necesita.
    let obj: any = {};
    obj['documento'] = {};
    obj['token'] = token;
    obj['companyParams'] = apiServer;
    // Si es necesario se descarga el documento pdf.
    await this.getUniqueDocument(this.idDocumento, 'false', obj);

    this.documents = this.documentos.documents[this.loopNum];

    // Pdf.
    if (this.documents && this.documents.document) {
      this.page = 1;
      this.pdfSrc = 'data:application/pdf;base64,' + this.documents.document;
      this.hasDocument = true;
    } else {
      this.hasDocument = false;
    }
  }

  // Obtener documento pdf.
  private getUniqueDocument(idDocument: any, returnDocument: string, companyParams: any): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.id && idDocument && companyParams) {
        let objConsulta = {
          documento: {
            reference: this.id,
            returnDocument: returnDocument,
            event: this.eventType,
            documentId: idDocument,
            isQsignerEmail: true,
          },
          companyParams: companyParams['companyParams'],
          token: companyParams['token'],
        };
        this.qsignerhomeService.getDocuments(this.url, objConsulta).subscribe((datos: any) => {
          if (datos && datos['documents'] && datos['documents'].length && this.documentos && this.documentos.documents && this.documentos.documents.length) {
            for (let i = 0; i < this.documentos.documents.length; i++) {
              if (this.documentos.documents[i].documentId == datos['documents'][0].documentId) {
                this.documentos.documents[i].document = datos['documents'][0].document;
                this.showDocumentPdf = true;
                resolve();
              }
            }
          } else {
            reject();
            this.notDownloadDocument = true;
            showToaster(this.toastService, 'error', this.translateService, 'COMMON.ERROR', this.error_get_document_label);
          }
        });
      } else {
        reject();
      }
    });
  }

  // Cargar documento firmado para visualización y descarga
  public loadSignedDocumentForDownload(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.elementToPrint) {
        reject('No document to print');
        return;
      }

      let objConsulta = {
        documento: {
          reference: this.id,
          returnDocument: 'true',
          event: this.eventType,
          documentId: this.elementToPrint,
          isRequestDownload: 'true',
        },
        companyParams: this.sp['companyParams'],
        token: this.sp['token'],
      };

      this.qsignerhomeService.getDocuments(this.url, objConsulta).subscribe(
        (datos: any) => {
          if (datos && datos['documents'] && datos['documents'].length > 0) {
            this.documentToPrint = {
              document: datos['documents'][0]['document'],
              description: datos['documents'][0]['description'],
            };
            // Configurar PDF para visualización
            this.page = 1;
            this.pdfSrc = 'data:application/pdf;base64,' + datos['documents'][0]['document'];
            this.hasDocument = true;
            this.showDocumentPdf = true;
            resolve();
          } else {
            reject('No document found');
          }
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  // Descargar documentos firmados.
  public downloadSingDocument(event: any) {
    return new Promise<void>((resolve, reject) => {
      this.loadingDownloadSingDocument = true;

      // Si ya tenemos el documento cargado (por ejemplo, desde loadSignedDocumentForDownload),
      // usarlo directamente sin hacer otra petición
      if (this.documentToPrint && this.documentToPrint.document) {
        this.downloadOneDocument()
          .then(() => {
            this.loadingDownloadSingDocument = false;
            resolve();
          })
          .catch((err) => {
            console.error('Error al descargar el documento:', err);
            this.loadingDownloadSingDocument = false;
            reject();
          });
        return;
      }

      // Si no está cargado, hacer la petición al servidor
      const objConsulta = {
        documento: {
          reference: this.id,
          returnDocument: 'true',
          event: this.eventType,
          documentId: this.elementToPrint,
          isRequestDownload: 'true',
        },
        companyParams: this.sp['companyParams'],
        token: this.sp['token'],
      };

      this.qsignerhomeService.getDocuments(this.url, objConsulta).subscribe(async (datos: any) => {
        const [firstDocument] = datos?.documents || [];

        if (firstDocument?.document) {
          const { document, description } = firstDocument;

          this.documentToPrint = {
            document,
            description,
          };

          try {
            await this.downloadOneDocument();
            resolve();
          } catch (err) {
            console.error('Error al descargar el documento:', err);
            reject();
          } finally {
            this.loadingDownloadSingDocument = false;
          }
        } else {
          console.error('Documento base64 no válido');
          this.loadingDownloadSingDocument = false;
          reject();
        }
      });
    });
  }

  // Descargar un documento PDF
  public downloadOneDocument(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        const base64 = this.documentToPrint?.document;

        if (!base64) {
          reject('Documento base64 no válido o vacío');
          return;
        }

        const cleanBase64 = base64.replace(/\s/g, '');
        const byteCharacters = atob(cleanBase64);

        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        // Convertimos los bytes en un array binario y creamos el blob
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        const fileName = 'Impreso.pdf';

        if (this.nativo === true) {
          this.oLangWebViewInterface.emit('downloadFile', base64);
          resolve();
          return;
        }
        // Detectamos si estamos en iOS usando UIWebView (antiguo)
        const is_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);
        if (!is_uiwebview) {
          const newWindow = window.open(blobUrl, '_blank');
          if (newWindow && typeof newWindow.closed !== 'undefined') {
            resolve();
            return;
          }
        }
        // Si el navegador bloqueó el popup, continuamos con descarga directa forzamos la descarga con un <a> oculto

        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        resolve();
      } catch (e) {
        console.error('Error al decodificar o descargar el documento:', e);
        reject(e);
      }
    });
  }

  public afterLoadComplete(pdfData: any): void {
    this.totalPages = pdfData.numPages;
    this.isLoaded = true;
  }

  /*
    BARRA DE NAVEGACIÓN INFERIOR.
  */

  // Botón avanzar para cambiar de documento.
  public async changeDocument(): Promise<void> {
    let isRequired = this.isRequiredFields();
    // Comprobar los campos requeridos.
    if (isRequired) {
      // Posicionarse en la parte superior de la pantalla.
      scrollToTop();
      // Actualizar el número de documento que se quiere mostrar.
      let total = this.totalDocuments - 1;
      // Controlar si la siguiente es la última.
      if (this.currentDocument < total) {
        // Enviar firmas al DMS.
        await this.sendDocumentData();
        this.currentDocument = this.currentDocument + 1;
        // this.hasDocument = false;
        this.obtenerInfo();
      } else {
        // Enviar firmas al DMS.
        await this.sendDocumentData();
        // Si es la última pantalla ocultar el resto.
        if (this.requiereCustomer === 'false') {
          this.documentos.documents.forEach((doc: any) => {
            if (this.modelo['file-' + doc['documentId']]) {
              this.documentosToDownload.push(doc);
              this.elementToPrint = doc['documentId'];
            }
          });
        } else {
          this.documentosToDownload = this.documentos.documents;
          if (this.documentosToDownload.length > 0) {
            this.elementToPrint = this.documentosToDownload[0]['documentId'];
          }
        }

        // Para el caso de un único documento, cargar el documento antes de mostrar la pantalla
        if (this.totalDocuments === 1 && this.documentosToDownload.length === 1) {
          // Mantener el loading activo mientras se carga el documento
          this.loadingData = true;

          // Obtener el documento firmado para visualización y descarga
          await this.loadSignedDocumentForDownload();

          // Ahora sí mostrar la pantalla con todo listo
          this.loadingData = false;
          this.loadingDocument = false;
          this.showDocumentList = false;
          this.hasBanners = false;
          this.showData = false;
          this.showDownloadScreen = true;

          // Descargar automáticamente después de un breve delay
          setTimeout(() => {
            this.downloadSingDocument(null);
          }, 500);
        } else {
          // Para múltiples documentos, mostrar la pantalla normalmente
          this.loadingData = false;
          this.loadingDocument = false;
          this.showDocumentList = false;
          this.hasBanners = false;
          this.showData = false;
          // Mostrar la última pantalla.
          this.showDownloadScreen = true;
        }
      }
    } else {
      if (this.typeRequiredError === 'Empty') {
        showToaster(this.toastService, 'warning', this.translateService, 'COMMON.WARNING', this.require_fields_label);
      } else {
        showToaster(this.toastService, 'warning', this.translateService, 'COMMON.WARNING', this.require_require_max_size_sing_label);
      }
      this.typeRequiredError = '';
    }
  }

  // Enviar documento cada vez que se firme.
  public sendDocumentData(): Promise<void> {
    return new Promise((resolve: any, reject: any) => {
      if (this.requiereCustomer == 'true' || this.email.indexOf('@') >= 0 || (this.phoneNumber && this.phoneNumber.length && this.phoneNumber.length >= 9)) {
        this.loadingSendDocuments = true;
        // Crear objeto
        let obj: any = {};
        obj['token'] = this.sp['token'];
        obj['companyParams'] = this.sp['companyParams'];
        // Crear id del docuimento.
        let doc: string = this.idDocumento + '*' + this.id + '*gateway*' + this.documents.eventId;
        obj['respuesta'] = {};
        obj['respuesta']['documentId'] = doc;
        // otros datos:
        obj['respuesta']['headText'] = 'string';
        obj['respuesta']['deviceId'] = 'string';
        obj['respuesta']['category'] = 1;
        obj['respuesta']['isGenerateDocument'] = true;
        obj['respuesta']['isRemote'] = this.requiereCustomer == 'true' ? true : false;
        obj['respuesta']['isSMS'] = this.requiereCustomer == 'false' && this.phoneNumber !== undefined ? true : false;
        obj['respuesta']['isQSignerEmail'] = 'true';
        obj['respuesta']['emailToSend'] = this.requiereCustomer == 'false' && this.email !== undefined ? this.email : undefined;
        obj['respuesta']['mobileToSend'] = this.requiereCustomer == 'false' && this.phoneNumber !== undefined ? this.phoneNumber : undefined;
        obj['respuesta']['reference'] = this.id;
        obj['respuesta']['selectedDocuments'] = this.selectedDocumentsList.join(',');
        // Autorizaciones.
        if (this.documents && this.documents['authorizationId']) {
          obj['respuesta']['authorizationId'] = this.documents['authorizationId'];
        }
        // Autorizaciones contenido.
        if (this.documents['authorization']) {
          let auths: any[] = [];
          this.documents['authorization'].forEach((e: any) => {
            let auth = {
              authorizationId: e['authorizationId'],
              authorizationResult: this.model[e['authorizationId']],
            };
            auths.push(auth);
          });
          obj['respuesta']['authorization'] = auths;
        }
        // firmas.
        obj['respuesta']['signatureId'] = ''; // FALTA
        // Firmas contenido.
        if (this.firmas && this.firmas.toArray() && this.firmas.toArray().length > 0) {
          let sings: any[] = [];
          this.firmas.toArray().forEach((e: any) => {
            const id = e['element']['id'].split('-');
            let sing = {
              signatureId: id[1],
              signature: this.cleanBase64Img(e.getSignature()),
            };
            sings.push(sing);
          });
          obj['respuesta']['signatures'] = sings;
        }
        this.qsignerService.postSignature(this.url, obj).subscribe({
          next: (res: any) => {
            if (res && res['code'] && res['code'] === 'dms_error') {
              showToaster(this.toastService, 'error', this.translateService, 'COMMON.ERROR', res['message']);
            } else {
              showToaster(this.toastService, 'success', this.translateService, 'COMMON.SUCCESS', this.send_data_label);
            }
            this.loadingSendDocuments = false;
            resolve();
          },
          error: (error) => {
            this.loadingSendDocuments = false;
            reject();
          },
        });
      } else {
        showToaster(this.toastService, 'success', this.translateService, 'COMMON.SUCCESS', 'Faltan campos para el envio');
      }
    });
  }

  // Función para el botón de mostrar los documentos Pdf.
  public async showDocuments(): Promise<void> {
    if (!this.hasDocument) {
      this.loadingDocument = true;

      // Obtener el id del documento del que se quieren cojer las firmas.
      this.idDocumento = this.ids[this.currentDocument].replace('file-', '');
      // Preparar opciones para la consulta acerca del documento que se necesita.
      let obj: any = {};
      obj['documento'] = {};
      obj['token'] = this.sp['token'];
      obj['companyParams'] = this.sp['companyParams'];
      obj['documento']['eventId'] = 11;
      obj['documento']['reference'] = this.id;
      // Si es necesario se descarga el documento pdf.

      await this.getUniqueDocument(this.idDocumento, 'true', obj);
      // Pdf.
      if (this.documents && this.documents.document) {
        this.page = 1;
        this.pdfSrc = 'data:application/pdf;base64,' + this.documents.document;
        this.hasDocument = true;
        this.showDocumentPdf = true;
      } else {
        this.hasDocument = false;
      }
      this.loadingDocument = false;
    }

    // Posicionarse en la parte superior de la página.
    scrollToTop();

    setTimeout(() => {
      // this.pdfViewer.
      this.pdfViewer.src = this.pdfSrc;
    }, 500);
  }

  // Comprobar si es requerido.
  private isRequiredFields(): boolean {
    let f = this.firmas.toArray();
    let result: boolean = true;
    // Comprobar firmas.
    this.documents?.['signatures']?.forEach((e: any) => {
      if (e['required'] && e['signatureId']) {
        f.forEach((x: any) => {
          let id = x['element'] && x['element']['id'] ? x['element']['id'].replace('sig-', '') : undefined;
          let xblob = x.saveAsBlob();
          if (id && e['signatureId'] === id && x.isEmpty()) {
            this.typeRequiredError = 'Empty';
            result = false;
          }
          if (id && e['signatureId'] === id && xblob.size < this.sizeSign && !x.isEmpty()) {
            this.typeRequiredError = 'Size';
            result = false;
          }
        });
      }
    });

    // Comprobar valores requeridos.
    if (this.documents.authorization && this.requiereCustomer === 'true') {
      this.documents.authorization.forEach((element: any) => {
        if (element.requiredAuthentication) {
          // Comprobar valores de los radio buttons (tipo 1).
          if (!element['value'] && element['authorizationType'] === 1) {
            this.typeRequiredError = 'Empty';
            result = false;
          }
          // Comprobar valores de los input de texto (tipo 2).
          if (element['authorizationType'] === 2 || element['authorizationType'] === 5 || element['authorizationType'] === 4) {
            let value = this.model[element['authorizationId']];
            if (!value) {
              this.typeRequiredError = 'Empty';
              result = false;
            }
          }
        }
      });
    }
    return result;
  }

  // Limpiar imagen en Base64.
  private cleanBase64Img(imgBase64: any): any {
    return imgBase64.substr(imgBase64.indexOf(',') + 1);
  }

  // Botón terminar, cerrar la pestaña del navegador.
  public close(): void {
    // @grant window.close
    setTimeout(() => {
      let w: any = window;
      if (window) {
        this.oLangWebViewInterface.emit('goBack', true);
        w.open('', '_self').close();
      }
    }, 500);
    setTimeout(window.close, 1000);
    window.close();
  }

  /*
    BARRA DE NAVEGACIÓN PARA LOS PDFs.
  */

  // Avanza página (hasta llegar a la última).
  public nextPage(): void {
    this.page++;
  }

  // Retrocede página (hasta llegar a la última).
  public prevPage(): void {
    this.page--;
  }

  // Aumentar zoom (hasta 3 niveles).
  public zoom_in(): void {
    this.zoom = this.zoom + 0.5;
  }

  // Disminuir zoom (hasta el nivel 1).
  public zoom_out(): void {
    this.zoom = this.zoom - 0.5;
  }

  // Imprimir un documento.
  public printDocument(event: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        let base64String = '';
        // Decode base64 string
        if (this.documentPrint !== undefined) {
          base64String = this.documentPrint;
        } else {
          base64String = this.documentos.documents[this.loopNum]?.document || '';
        }

        if (!base64String) {
          reject('Documento base64 no válido');
          return;
        }

        // Intentar decodificar base64
        const cleanBase64 = base64String.replace(/\s/g, '');
        const byteCharacters = atob(cleanBase64);

        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);

        const file = {
          filename: 'Impreso',
          base64: this.pdfSrc?.split('data:application/pdf;base64,')[1] || '',
          type: 'pdf',
        };

        if (this.nativo === true) {
          this.oLangWebViewInterface.emit('downloadFile', file.base64);
          resolve();
          return;
        }

        const is_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);
        if (!is_uiwebview) {
          window.open(blobUrl.toString(), '_blank');
          resolve();
          return;
        }

        // Forzar descarga
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = file.filename;
        link.dispatchEvent(new MouseEvent('click'));

        resolve();
      } catch (error) {
        console.error('Error al imprimir documento:', error);
        reject(error);
      }
    });
  }

  /*
    PARA LAS FIRMAS.
  */

  // Borrar firma del componente por id.
  public clearSignatureComponentById(id: any): void {
    // Buscar el id de la firma que se quiere borrar.
    this.firmas.toArray().forEach((element) => {
      if (element && element['element'] && element['element']['id'] && element['element']['id'] === id) {
        // Borrar la firma.
        delete element['endPoint'];
        element.clear();
      }
    });
  }

  /*
    PARA LOS TAB DE LAS FIRMAS.
  */

  // Con cada click sobre un tab o document se ocultan todas las firmas y su botón de borrar asociado.
  public ocultarSignatures(event: any, ids: any) {
    this.documentos['documents'].forEach((e: any) => {
      if (e['signatures']) {
        e['signatures'].forEach((e2: any) => {
          if (e2['signatureId'] === ids) {
            e2['visible'] = e2['visible'] === false ? true : false;
          }
        });
      }
    });
  }

  // Evento para cuando se firma.
  public changeSignature(): void {
    this.firmas.toArray().forEach((e: any) => {
      let obj = {
        id: e['element']['id'],
        signature: this.cleanBase64Img(e.getSignature()),
      };
    });
  }

  /*
    PARA LOS CHECKBOX DE LA PANTALLA INICIAL.
  */

  // Añadir o eliminar del modelo los ficheros seleccionados.
  public changeSelectFiles(fileId: any): void {
    let element: any = document.querySelector('#' + fileId);
    this.elementToPrint = element.id.replace('file-', '');

    // Limpiar el documento cacheado cuando se cambia de selección
    this.documentToPrint = null;
    this.hasDocument = false;
    this.showDocumentPdf = false;

    if (element['checked'] === false) {
      this.modelo[fileId] = undefined;
      delete this.modelo[fileId];
    }

    let anyCheckBox = Object.keys(this.modelo);
    let control = false;
    if (anyCheckBox && anyCheckBox.length > 0) {
      for (let i = 0; i < anyCheckBox.length; i++) {
        if (anyCheckBox[i].includes('file-') && !anyCheckBox[i].includes('file-data')) {
          this.modelo['file-data'] = true;
          control = true;
        }
      }
      if (control === false) {
        delete this.modelo['file-data'];
      }
    }

    // Check if documents have been checked
    if (Object.keys(this.modelo).length > 0) {
      this.checkedDocuments = true;
    } else {
      this.checkedDocuments = false;
    }

    // Obtener todos los documentos seleccionados por el cliente en la primera pantalla.
    let aux: String[] = [];
    anyCheckBox.forEach((document: string) => {
      if (document !== 'file-data') aux.push(document.replace('file-', ''));
    });
    this.selectedDocumentsList = aux;
  }

  /*
    PARA EL TAB DE LAS AUTORIZACIONES.
  */

  // Con cada click sobre o document se ocultan todos los tabsets.
  public ocultarTabsetss(id: any): void {
    this.documents.authorization.forEach((c: any, i: number) => {
      if (c['authorizationId'] === id) {
        c['visible'] = c['visible'] === false ? true : false;
      }
    });
  }

  /*
    PARA LOS DESPLEGABLES DE LAS OPCIONES (PENDIENTE DE REVISAR).
  */

  // Si el checkbox no esta seleccionado, lo elimina del modelo.
  public changeCheckBox(value: any, id: any, ngmodel: any): void {
    // Obtener el elemento.
    var element: any = document.getElementById(id);
    // Eliminar si no esta marcado.
    if (element.checked === false) {
      this.model[id] = undefined;
      delete this.model[id];
    }
    let anyCheckBox = Object.keys(this.model);
    let control = false;
    if (anyCheckBox && anyCheckBox.length > 0) {
      for (let i = 0; i < anyCheckBox.length; i++) {
        if (anyCheckBox[i].includes('checkbox-') && !anyCheckBox[i].includes('checkbox-data')) {
          this.model['checkbox-data'] = true;
          control = true;
        }
      }
      if (control === false) {
        delete this.model['checkbox-data'];
      }
    }
  }

  /*
    PENDIENTE.
  */

  // Resetear autorizacion.
  public borrarAuthorization(id: any): void {
    let expresion = id.split('-')[0];
    let identifier = id.split('-')[1];
    let keys;
    switch (expresion) {
      case 'checkbox':
        let keysCheck = Object.keys(this.model);
        let keysCheckLength = keysCheck.length;
        if (keysCheck && keysCheck.length > 0) {
          for (let i = 0; i < keysCheckLength; i++) {
            let inputs: any = document.querySelectorAll('#' + id + ' input');
            if (inputs && inputs.length && inputs.length > 0) {
              for (let j = 0; j < inputs.length; j++) {
                if (inputs[j]['id'] === identifier && inputs[j].checked) {
                  inputs[j].checked = false;
                  delete this.model[inputs[j].id];
                }
              }
            }
          }
        }
        delete this.model['checkbox-data'];
        break;
      case 'radio':
        // Borrar autorizaciones.
        this.documents['authorization'].forEach((e: any) => {
          if (e['authorizationId'] === identifier) {
            e['value'] = undefined;
          }
        });
        keys = Object.keys(this.model);
        if (keys && keys.length > 0) {
          for (let i = 0; i < keys.length; i++) {
            let radio = id.split('-')[1].indexOf(keys[i]);
            let tabId = 'tab-' + keys[i];
            let tabElement: any = document.getElementById(tabId);
            let inputs = tabElement.getElementsByTagName('input');
            if (inputs && inputs.length && inputs.length > 0) {
              for (let j = 0; j < inputs.length; j++) {
                if (inputs[j]['id'] === identifier && inputs[j].checked) {
                  inputs[j].checked = false;
                  delete this.model[keys[i]];
                }
              }
            }
          }
        }
        break;
      case 'textarea':
        keys = Object.keys(this.model);
        if (keys && keys.length > 0) {
          for (let i = 0; i < keys.length; i++) {
            let radio = id.split('-')[1].indexOf(keys[i]);
            let tabElement: any = document.getElementById('tab-' + keys[i]);
            let inputs = tabElement.getElementsByTagName('textarea');
            if (inputs && inputs.length && inputs.length > 0) {
              for (let j = 0; j < inputs.length; j++) {
                if (inputs[j]['id'] === identifier) {
                  inputs[j].value = '';
                }
              }
              delete this.model[keys[i]];
            }
          }
        }
        break;
      default:
        let keysDatePicker = Object.keys(this.model);
        if (keysDatePicker && keysDatePicker.length > 0) {
          for (let i = 0; i < keysDatePicker.length; i++) {
            let datePicker = id.split('-')[1].indexOf(keysDatePicker[i]);
            if (datePicker >= 0) {
              this.model[keysDatePicker[i]] = 0;
              delete this.model[keysDatePicker[i]];
            }
          }
        }
        break;
    }
  }

  // Obtener valor de un radio button.
  public changeRadioButton(event: any, type: number): void {
    // Obtener valores.
    let id: string = event && event['currentTarget'] && event['currentTarget']['id'] ? event['currentTarget']['id'] : undefined;
    let valor: boolean = event && event['returnValue'] ? event['returnValue'] : undefined;
    // Añadir valor del radio button.
    if (id !== undefined && valor !== undefined) {
      this.documents.authorization.forEach((element: any) => {
        if (element['authorizationId'] == id && element['authorizationType'] === type) {
          element['value'] = valor;
        }
      });
    }
  }

  /*
    TRATAMIENTO DE LOS DATOS.
  */

  // Metodo para formatear todos los textos.
  public decodeHtmlEntities(str: any) {
    // Crear un elemento temporal para usar la función browser incorporada
    let tempElement = document.createElement('textarea');

    // Utilizar un regex para encontrar todas las entidades numéricas
    return str.replace(/&#(\d+);/g, (match: any, dec: any) => {
      // Establecer el valor de la entidad en el elemento temporal
      tempElement.innerHTML = `&#${dec};`;
      // Devolver el texto decodificado
      return tempElement.value;
    });
  }

  /**
   * Calcular tamaño del componente de firma.
   * @returns {void}
   */
  public setDynamicSize(): void {
    let signElement: any = this.documentDOM.querySelector('.signature-component');
    if (signElement) {
      let widthElement: number = signElement.width;
      if (widthElement > 800) {
        this.sizeSign = 5500;
      } else if (widthElement < 800 && widthElement > 600) {
        this.sizeSign = 4000;
      } else if (widthElement < 600 && widthElement > 500) {
        this.sizeSign = 3500;
      } else {
        this.sizeSign = 3000;
      }
    }
  }

  // Obtener los parámetros actuales de la URL
  /**
   * Envia un mensaje de WhatsApp con el enlace de QSigner.
   *
   * Flujo:
   * 1. Lee los parámetros actuales de la URL y los copia.
   * 2. Fuerza el parámetro "h" a true (encriptado con manageAES) para indicar modo remoto.
   * 3. Construye el parámetro "m" con la lista de documentId seleccionados (o todos si no hay selección) y lo encripta.
   * 4. Reconstruye la URL a /#/qsignerhome con los parámetros resultantes.
   * 5. Acorta la URL usando `shortenUrl` (si falla devuelve cadena vacía y continúa con la larga).
   * 6. Construye el texto del mensaje y abre WhatsApp Web o la app nativa según el contexto.
   *
   * Notas:
   * - Usa `selectedDocumentsList` (ids elegidos por el usuario) o `documentos.documents`
   * - Si no se logra obtener/crear el parámetro m, simplemente se omite.
   * - `this.nativo` determina si se invoca a la capa nativa mediante `oLangWebViewInterface`.
   * - Sanitiza el número de teléfono quitando caracteres no numéricos antes de construir la URL.
   *
   * Edge cases manejados:
   * - Sin documentos seleccionados ni disponibles: se omite "m".
   * - Fallo al acortar URL: se usa la URL original.
   *
   */
  sendWhatsAppMessageWithQSignerURL(): void {
    // Crear un objeto para almacenar los parámetros actuales
    const currentParams: { [key: string]: string } = {};

    this.activatedRoute.queryParams.pipe(take(1)).subscribe(async (params) => {
      // Copiar todos los parámetros existentes
      Object.keys(params).forEach((key) => {
        currentParams[key] = params[key];
      });

      // Añadir o modificar el parámetro 'h' a true (encriptado)
      currentParams['h'] = manageAES('true', 'encrypt');

      // Parametro 'm': lista de documentId separados por coma.
      // Prioriza los documentos seleccionados por el usuario; si no hay selección usa todos.
      let documentIds: string[] = [];
      try {
        if (this.selectedDocumentsList?.length) {
          documentIds = this.selectedDocumentsList.map((id: any) => id?.toString()).filter((v: string) => !!v && v.trim() !== '');
        } else if (this.documentos?.documents?.length) {
          documentIds = this.documentos.documents
            .map((d: any) => d?.documentId || d?.documentID || d?.id)
            .filter((v: any) => !!v)
            .map((v: any) => v.toString().trim())
            .filter((v: string) => v !== '');
        }
      } catch (e) {
        console.warn('Error obteniendo documentos para param m:', e);
      }

      if (documentIds.length) {
        // Encriptar el parámetro 'm' (lista de documentos) antes de codificar en la URL
        try {
          const mRaw = documentIds.join(',');
          const mEncrypted = manageAES(mRaw, 'encrypt');
          currentParams['m'] = mEncrypted;
        } catch (e) {
          console.warn('No se pudo encriptar el parámetro m, se omite.', e);
        }
      } else {
        delete currentParams['m'];
      }

      // Construir la cadena de consulta
      let queryString = '';
      Object.keys(currentParams).forEach((key) => {
        if (queryString) {
          queryString += '&';
        }
        queryString += `${key}=${encodeURIComponent(currentParams[key])}`;
      });

      // Generar la URL completa
      const baseUrl = window.location.origin;
      let qsignerUrl: string = `${baseUrl}/#/qsignerhome?${queryString}`;
      const shortUrl = await this.shortenUrl(qsignerUrl);
      qsignerUrl = shortUrl || qsignerUrl;

      // Crear el mensaje completo con texto introductorio
      const messageText = `Solicitud de firma online:

Acceda al siguiente enlace para revisar y firmar la documentación:
${qsignerUrl}`;

      // Verificar si es dispositivo nativo (móvil) o navegador web
      const checkIsNative = this.nativo;

      // Construir la URL de WhatsApp
      let whatsAppURL = 'https://api.whatsapp.com';
      const clearTelephone = this.phoneNumber.toString().replace(/\D/g, '');
      whatsAppURL += '/send?phone=' + clearTelephone;

      whatsAppURL += `&text=${encodeURIComponent(messageText)}`;

      // Abrir WhatsApp según el entorno (móvil o navegador)
      if (checkIsNative) {
        // Si está en móvil, usar la interfaz nativa
        this.oLangWebViewInterface.emit('openOtherApp', `${whatsAppURL}`);
      } else {
        // Si está en navegador, abrir WhatsApp Web en una nueva pestaña
        window.open(`${whatsAppURL}`, '_blank');
      }
    });
  }

  /**
   * Acorta una URL usando el servicio `UrlShortenerService`.
   *
   * Resoluciones posibles:
   * - Éxito: resuelve con la URL acortada.
   * - Respuesta vacía/nula: resuelve con cadena vacía para permitir fallback a la URL original.
   * - Error HTTP: rechaza la promesa.
   *
   * @param url URL larga original que se desea acortar.
   * @returns Promise<string> que resuelve con la URL acortada o '' si no fue posible.
   */
  shortenUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.urlShortenerService.shortenUrl(url).subscribe({
        next: (shortenedUrl) => {
          resolve(shortenedUrl);
        },
        error: (error) => {
          console.error('Error:', error);
          reject(error);
        },
      });
    });
  }
}
